import Footer from "../../components/footer/Footer";
import "./contact.css";
import IMAGES from "../../images/images";
import MailForm from "../../components/mailForm/MailForm";
import Map from "../../components/map/Map";

export default function Contact() {
    return (
        <div className="contact">
            <div className="contact__wrapper">
                <div className="contact__img">
                    <img src={IMAGES.contactImg} alt="" />
                </div>
                <div className="contact__formWrapper">
                    <MailForm />
                </div>
            </div>
            <div className="contact__mapFooter">
                <Map />
                <Footer />
            </div>
        </div>
    )
}
